var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartTable"},[_c('gat-grid',{staticClass:"elevation-0",class:_vm.gridClass,attrs:{"allowHtml":"","fixedheader":true,"height":_vm.gridHeight,"columns":_vm.calcColumns,"items":_vm.rowData,"dense":true,"stickyFirstColumn":_vm.stickyFirstColumn === 1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }